import { ILeaderboardRow } from './leaderboard-row.interface';
import { ILeaderboardTable } from './leaderboard-table.interface';

export interface ILeaderboardTableWithScores extends ILeaderboardTable {
    scores: ILeaderboardRow[];
}